import React, { useState, useEffect } from "react";
import { updateBanner } from "../../utils/bannerService";
import { uploadImage } from "../../utils/imageUploadService";
import useFetchBanners from "../../hooks/useFetchBanners";

const BannerForm = () => {
  const [formData, setFormData] = useState({
    num: "",
    eventTitle: "",
    eventTitle_fr: "",
    imageURL: "",
    link: "",
    bannerDisplay: false,
  });

  const { banners, loading, error, reloadBanners } = useFetchBanners();

  const [currentBannerId, setCurrentBannerId] = useState("");
  const [currentBannerNum, setCurrentBannerNum] = useState("");
  const [currentBanner, setCurrentBanner] = useState("");
  const [currentBanner_fr, setCurrentBanner_fr] = useState("");
  const [currentLink, setCurrentLink] = useState("");
  const [bannerDisplay, setBannerDisplay] = useState(false);

  useEffect(() => {
    if (banners && banners.length > 0) {
      console.log("Banners fetched successfully:", banners);
    }
  }, [banners]);

  if (loading) return <p>Loading banners...</p>;
  if (error) return <p></p>;

  // Update for consistency
  const handleImageUpload = (e) => {
    const bannerImage = e.target.files[0];
    // validate bannerImage file type to be PNG
    if (bannerImage.type !== "image/png") {
      alert("Please upload a PNG file");
      return;
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      bannerImage: bannerImage,
    }));
    console.log(bannerImage);
  };

  // Handle other inputs
  const handleNumChange = (event) => {
    setFormData({
      ...formData,
      num: event.target.value,
    });
  };

  // Handle other inputs
  const handleEventTitleChange = (event) => {
    setFormData({
      ...formData,
      eventTitle: event.target.value,
    });
  };

  // Handle fr inputs
  const handleEventTitleFrChange = (event) => {
    setFormData({
      ...formData,
      eventTitle_fr: event.target.value,
    });
  };

  //Handle link inputs
  const handleLinkChange = (event) => {
    setFormData({
      ...formData,
      link: event.target.value,
    });
  };

  // Handle banner display toggle
  const handleBannerDisplayToggle = () => {
    setFormData({ ...formData, bannerDisplay: !bannerDisplay });
    setBannerDisplay(!bannerDisplay);
  };

  const handleClick = (selectedNum) => {
    const banner = banners.find((banner) => banner.num === selectedNum);
    console.log("Banner clicked:", banner);

    setCurrentBannerId(banner._id);
    setCurrentBannerNum(banner.num);
    setCurrentBanner(banner.eventTitle);
    setCurrentBanner_fr(banner.eventTitle_fr);
    setCurrentLink(banner.link);
    setBannerDisplay(banner.bannerDisplay);
    setFormData({
      eventTitle: banner.eventTitle,
      eventTitle_fr: banner.eventTitle_fr,
      imageURL: banner.imageURL,
      link: banner.link,
      bannerDisplay: banner.bannerDisplay,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!currentBannerId) {
      alert("Please select a banner to update");
      return;
    }

    // if no image provided, only update the event title
    console.log("Form data:", formData);
    if (!formData.bannerImage) {
      try {
        const updateResponse = await updateBanner(currentBannerId, {
          num: formData.num,
          eventTitle: formData.eventTitle.trim(),
          eventTitle_fr: formData.eventTitle_fr.trim(),
          imageURL: formData.imageURL,
          link: formData.link,
          bannerDisplay: formData.bannerDisplay,
        });

        if (updateResponse.success) {
          console.log("Banner saved successfully:", updateResponse);
          alert("Banner saved successfully");
          return;
        } else {
          console.error("Failed to save banner:", updateResponse);
          alert("Failed to save banner");
          return;
        }
      } catch (error) {
        console.error("Failed to save banner:", error);
        alert("Failed to save banner");
        return;
      }
    } else {
      try {
        const uploadResponse = await uploadImage(
          currentBannerId,
          formData.bannerImage
        );

        if (uploadResponse.success) {
          console.log(
            "New banner image uploaded:",
            uploadResponse.data.imageURL
          );
          const updateResponse = await updateBanner(currentBannerId, {
            num: formData.num,
            eventTitle: formData.eventTitle.trim(),
            eventTitle_fr: formData.eventTitle_fr.trim(),
            imageURL: uploadResponse.data.imageURL,
            link: formData.link,
            bannerDisplay: formData.bannerDisplay,
          });

          if (updateResponse.success) {
            console.log("Banner saved successfully:", updateResponse);
            alert("Banner saved successfully");
            return;
          } else {
            console.error("Failed to save banner:", updateResponse);
            alert("Failed to save banner");
            return;
          }
        }
      } catch (error) {
        console.error("Failed to save banner:", error);
        alert("Failed to save banner");
      }
    }
    reloadBanners();
  };

  return (
    <div className="w-full bg-bgWhite rounded shadow-md p-10 my-10 border">
      <h2 className="text-2xl font-medium mb-4 text-center">Banner Form</h2>
      {/* Display all the banners info from Database */}
      <div className="mb-5 border bg-white text-sm">
        {/* Display all the banners info from Database */}
        <table className="table-fixed divide-y divide-gray-200 font-medium w-full">
          <thead className="bg-gray-50 uppercase text-gray-500 tracking-wider">
            <tr>
              <th scope="col" className="py-4 px-2">
                Number
              </th>
              <th scope="col" className="py-4 px-2">
                Event Title(English Version)
              </th>
              <th scope="col" className="py-4 px-2">
                Event Title(French Version)
              </th>
              <th scope="col" className="py-4 px-2">
                Banner ImageURL
              </th>
              <th scope="col" className="py-4 px-2">
                Link
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 text-center">
            {banners.map((banner, index) => (
              <tr key={index} onClick={() => handleClick(banner.num)}>
                <td className="text-gray-900 py-4 px-2">{banner.num}</td>
                <td className="text-gray-900 py-4 px-2 whitespace-normal break-words">
                  {banner.eventTitle}
                </td>
                <td className="text-gray-900 py-4 px-2 whitespace-normal break-words">
                  {banner.eventTitle_fr}
                </td>
                <td className="text-gray-500 py-4 px-2 whitespace-normal break-words">
                  <img src={banner.imageURL} alt={banner.eventTitle} />
                </td>
                <td className="text-gray-900 py-4 px-2 whitespace-normal break-words">
                  {banner.link}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <form id="banner-form" onSubmit={handleSubmit} className="space-y-4">
        <label className="block text-lg font-medium">Number:</label>
        <input
          name="num"
          placeholder={currentBannerNum}
          value={formData.num}
          onChange={handleNumChange}
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 bg-gray-200"
          readOnly
        />
        {/* New Event input */}
        <label className="block text-lg font-medium text-blue-700">
          Event title:(English Version)
        </label>
        <textarea
          name="eventTitle"
          placeholder={currentBanner}
          value={formData.eventTitle}
          onChange={handleEventTitleChange}
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
        />
        <label className="block text-lg font-medium  text-red-600">
          Event title:(French Version)
        </label>
        <textarea
          name="eventTitle_fr"
          placeholder={currentBanner_fr}
          value={formData.eventTitle_fr}
          onChange={handleEventTitleFrChange}
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
        />

        {/*Display the selected banner link */}
        <label className="block text-lg font-medium text-black">Link</label>
        <textarea
          name="link"
          placeholder={currentLink}
          value={formData.link}
          onChange={handleLinkChange}
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
        />

        {/* Banner Image input */}
        <label className="block text-lg font-medium">Banner Image:</label>
        <input
          type="file"
          name="bannerImage"
          onChange={handleImageUpload}
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
        />

{/* Display the selected banner display */}
<div className="w-full bg-bgWhite rounded py-4 font-medium text-xl">
  <label className="flex items-center cursor-pointer gap-3">
    Banner Display:
    <div className="relative">
      {/* Hidden checkbox */}
      <input
        type="checkbox"
        id="toggle"
        className="sr-only"
        onChange={handleBannerDisplayToggle}
        checked={bannerDisplay}
        value={bannerDisplay}
      />
      {/* Line */}
      <div
        className={`block w-14 h-8 rounded-full transition-colors ${
          bannerDisplay ? "bg-green-500" : "bg-gray-600"
        }`}
      ></div>
      {/* Dot */}
      <div
        className={`dot absolute top-1 w-6 h-6 rounded-full transition-transform ${
          bannerDisplay ? "translate-x-6 bg-white" : "translate-x-1 bg-white"
        }`}
      ></div>
    </div>
    {/* Label */}
    <div className="ml-3 text-font-medium">
      {bannerDisplay ? "On" : "Off"}
    </div>
  </label>
</div>

      </form>

      <div className="flex justify-center gap-10 pt-6">
        <button
          type="submit"
          form="banner-form"
          className="bg-customRed text-white text-xl w-36 py-1 rounded hover:font-bold hover:bg-red-800"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default BannerForm;
